
import styled from 'styled-components'
import { devices } from '../../../../globalStyle'

export const GridContainer = styled.div `
    display: grid;
    grid-template-areas:
    "titleNew titleNew titleNew titleNew"
    "statusLabel status vehicleLabel vehicle"
    "dateLabel date trackLabel track"
    "responsibleLabel responsible . ."
    "table table table table"
    ;
    gap: 1rem;
    border: 1px dashed #ccc; /* Bordas para depuração */
    grid-template-columns: repeat(4, minmax(200px, 1fr));
    grid-template-rows: auto; /* Alturas dinâmicas */
    padding: 2rem; /* Adiciona espaçamento interno */
    gap: 0rem; /* Espaço entre os elementos */
`

export const TableContainer = styled.div`

`

export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
`
export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 62.5vw auto;
    margin-right: 0.7vw;
    
`

export const HeaderText = styled.h1` 
font-family: 'Inter', sans-serif;
font-size: 2vw;
font-weight: 700;
margin-top: 0;
margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;
    
    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`
   
export const Text = styled.p` 
font-family: 'Inter', sans-serif;
font-size: 1rem;
font-weight: 700;
margin-top: 1rem;
margin-bottom: 0;
`

export const TextLabel = styled.p` 
font-family: 'Inter', sans-serif;
font-size: 1rem;
font-weight: 0.2vw;
margin-top: 1rem;
margin-bottom: 0;
color:  #303030;
`


export const OptionsDiv = styled.div `
    display: flex;
    justify-content: flex-end;
    grid-area: options;
    margin-top: 1vw;
    margin-bottom: 1vw;
    height: 2rem;
    padding-right: 1rem;
    `

export const ButtonOfSection = styled.div`
  display: flex;
  align-items: center;
  width: auto;
  height: 2.2vw;
  background-color: #0090d3;
  border-radius: 1vw;
  cursor: pointer;
  padding:.7vw;
  margin-right: 3vw;
  @media ${devices.largeDesktop} {
    width: 10vw;
  }

  &.reverse{
    background-color: #fff;
    border: 1px solid #0090d3;
  }
`

export const ButtonOfSectionText = styled.p`
  color: #fff;
  font-weight: 600;
  font-size: 0.9vw;
  font-family: 'Inter', sans-serif;
  font-weight:700;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  @media ${devices.largeDesktop} {
    font-size: 0.6vw;
  }

  &.reverse{
    color: #0090d3;
  }
`

export const IconImg = styled.img`
  display: flex;
  height: 1.3vw;
  margin-right: 0.5vw;
  margin-left: 0.5vw;

  @media ${devices.largeDesktop} {
    height: 1vw;
  }
`

export const LineDiv = styled.div`
     background: #EBEBEB;
    height: 0.1px;
    grid-area: line;
    
    margin-top: 0.5vw;
`

export const Table = styled.table`
  overflow-x: scroll;
  text-align: start;
  border-collapse: collapse;
  width: 95%;
  padding-right: 4vw;
  padding-left: 4vw;
  margin-left: 1.5rem;
  grid-area: table;
  margin-bottom: 1rem;
  
`

export const DriverListDiv = styled.div`
position: relative;
display: flex;
background-color: #fff;
padding-bottom: 0.5rem;
padding-right: 0.5rem;
width: 13rem;
height: 8rem;
padding-top: 0.5rem;
border: solid #0090d3;
border-radius: 0.5rem;
flex-direction: column;

align-items: center;
overflow: auto;
  /* border: solid green; */

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ffffff; /* Cor do thumb do scrollbar */
    border-radius: 3px; /* Border radius do thumb */
  }

  &::-webkit-scrollbar-track {
    background: #c0c0c0; /* Cor de fundo do scrollbar */
    border-radius: 3px; /* Border radius do track */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555555; /* Cor do thumb ao passar o mouse por cima */
  }
`

export const HeaderRow = styled.tr`
  position: sticky;
  top: 0;
  height: 5vh;
`

export const ItemRow = styled.tr`
  height: 8vh;
  background-color: #ebebeb;
  box-sizing: border-box;
  font-weight: normal;
  &:hover {
    background-color: #F7F7F7;

    
    .edit-div {
      visibility: visible;
    }
    
  }
  border-bottom: 1px solid #d1d1d1; 
  
`

export const HeaderCell = styled.th`
  color: #696969;
  background-color: #fff;
  text-align: start;
  border: 0;
  font-size: 12px;
  font-weight: 400;
  padding: 0.5rem 1rem;
`

export const ItemCell = styled.td`
  text-align: start;
  font-size: 13px;
  padding: 0.8rem 1rem;
  color: #5c5c5c;
  border-bottom: px solid #5c5c5c;
  word-wrap: break-word;
  overflow-wrap: break-word;

  /* Ajustando larguras específicas */
  &:nth-child(1) { width: 5%;}  /* Ordem */
  &:nth-child(2) { width: 10%; } /* Número do frete */
  &:nth-child(3) { width: 20%; } /* Cliente/fornecedor */
  &:nth-child(4) { width: 5%; } /* Tipo */
  &:nth-child(5) { width: 40%; } /* Endereço */
  &:nth-child(6) { width: 20%; } /* Volume e peso */

  &.link {
    color: #0090d3;
    cursor: pointer;
  }
  a{
    color: #0090d3;
    cursor: pointer;
    text-decoration: none;
  }
`


export const ItemCellContainer = styled.div`
  display:flex;
  gap:0.3vw;
  align-items:center;

  .documentUrl {
    cursor:pointer;
    &:hover {
    color: #0090d3;
    }
  }
`
